import {
    NotificationsComponent,
    FavoriteComponent,
    ShortcutsComponent,
    NotificationAndFavoriteComponent,
    ImageViewerComponent,
    InfictiousInfoComponent,
    NotificationDynamicComponent,
    Test1Component,
    PatientVisitDiagnosisComponent,
    ConfirmPasswordComponent,
    ConfirmModalComponent,
    OutstandingBalanceBreakdownComponent,
    PostEApprovalComponent,
    MessengerComponent,
    SessionWarningModalComponent,
    PageHeaderComponent,
    ToolbarComponent,
    EmptyStateComponent,
    CardComponent,
} from './components';

import {
    BaAmChart,
    BaBackTop,
    BaCard,
    BaCheckbox,
    BaContentTop,
    BaMenuItem,
    BaMenu,
    BaMsgCenter,
    BaMultiCheckbox,
    BaPageTop,
    baMainMenu,
    baMainMenuItem,
    BaSidebar,
    baDynamicModulesMenuComponent,
    AppShellComponent,
    AppShellTopbarComponent,
    AppShellLogoComponent,
    AppShellLangSwitcherComponent,
    AppShellAccountMenuComponent,
    AppShellRailComponent,
    AppShellFlyoutComponent,
    ModuleSectionsTreeComponent,
    AppShellPinnedStripComponent,
} from './controls';


export const NGA_SYSTEM_COMPONENTS = [
    BaAmChart,
    BaBackTop,
    BaCard,
    BaCheckbox,
    BaContentTop,
    BaMenuItem,
    BaMenu,
    BaMsgCenter,
    BaMultiCheckbox,
    BaPageTop,
    baMainMenu,
    baMainMenuItem,
    BaSidebar,
    AppShellComponent,
    AppShellTopbarComponent,
    AppShellLogoComponent,
    AppShellLangSwitcherComponent,
    AppShellAccountMenuComponent,
    AppShellRailComponent,
    AppShellFlyoutComponent,
    ModuleSectionsTreeComponent,
    AppShellPinnedStripComponent,
    NotificationsComponent,
    FavoriteComponent,
    ShortcutsComponent,
    NotificationAndFavoriteComponent,
    ImageViewerComponent,
    InfictiousInfoComponent,
    NotificationDynamicComponent,
    Test1Component,
    PatientVisitDiagnosisComponent,
    ConfirmPasswordComponent,
    ConfirmModalComponent,
    OutstandingBalanceBreakdownComponent,
    PostEApprovalComponent,
    MessengerComponent,
    SessionWarningModalComponent,
    baDynamicModulesMenuComponent,
    PageHeaderComponent,
    ToolbarComponent,
    EmptyStateComponent,
    CardComponent,
];
